//для get запросы форматируем
export function prepareRequestparams(sort, filter, page, include) {
  if (!sort) sort = "-id";
  return {
    params: Object.assign(
      {},
      { sort: sort },
      filter ? { filter: filter } : {},
      page ? { page: page } : {},
      include ? { include: include.join(",") } : {}
    ),
  };
}
